module.exports = __webpack_public_path__ + "27f85065e3febbeddec088ace08a4a46.svg";